import { html } from "lit";
var icon_funnel_default = () => html`
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.54 6.88a2.46 2.46 0 0 0-.52-3.41c-.41-.3-.9-.47-1.42-.47H6.4C5.07 3 4 4.1 4 5.44c0 .5.16 1 .45 1.42l7.57 11.01v8.68A2.43 2.43 0 0 0 14.63 29c.59.02 1.17-.13 1.68-.44l2.63-1.67c.6-.46.96-1.18.96-1.95v-7.05l7.64-11Zm-9.9 10.06c-.17.25-.27.55-.27.85v7.65c0 .2-.1.4-.29.5l-1.65.98a.59.59 0 0 1-.88-.51v-8.62c0-.3-.1-.6-.27-.84L6.61 5.93A.6.6 0 0 1 7.09 5H24.9a.59.59 0 0 1 .48.93l-7.75 11Z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_funnel_default as default
};
//# sourceMappingURL=icon-funnel.js.map
